module.exports = "/React/dist/b00ccc98098824916066ce36f4839764.png";